module.exports = __webpack_public_path__ + "img/bulb-mobile.482268de.png";